export const SET_TEEUP_NAME = "SET_TEEUP_NAME"
export const SET_TEEUP_IMAGE = "SET_TEEUP_IMAGE"
export const SET_TEEUP_MESSAGE = "SET_TEEUP_MESSAGE"
export const SET_INVITEES = "SET_INVITEES"
export const SET_IS_INVITEES_OPEN = "SET_IS_INVITEES_OPEN"
